export const errorTransformer = (error): string =>
  error.body?.message || error.body?.errors?.join('/n') || error.message || 'Something went wrong';
